<app-loading
  [loading] = loading
></app-loading>
<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Titulo="Financeiro"
      Pagina="Financeiro"
    ></app-breadcrumb>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-blue" style="margin-top:10px;padding-top: 7px">
              <div class="card-body">
                <ul class="menu-financeiro">
                  <li class="nav-item">
                    <a class="nav-link" [class.active]="abaAtiva === 'dashboard'" (click)="setAba('dashboard')" style="cursor: pointer">
                      <i class="fa fa-dashboard"></i> Dashboard
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" [class.active]="abaAtiva === 'contas-pagar'" (click)="setAba('contas-pagar')" style="cursor: pointer">
                      <i class="fa fa-minus-circle"></i> Conta a pagar
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" [class.active]="abaAtiva === 'contas-receber'" (click)="setAba('contas-receber')" style="cursor: pointer">
                      <i class="fa fa-plus-circle"></i> Conta a receber
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" [class.active]="abaAtiva === 'orcamento'" (click)="setAba('orcamento')" style="cursor: pointer">
                      <i class="fa fa-calendar"></i> Orçamento Mensal
                    </a>
                  </li>
                </ul>
                <app-financeiro-dashboard *ngIf="abaAtiva === 'dashboard'"></app-financeiro-dashboard>

                <!-- Lista de Contas a Pagar -->
                <app-financeiro-contas-pagar
                  *ngIf="abaAtiva === 'contas-pagar'"
                ></app-financeiro-contas-pagar>

                <!-- Lista de Contas a Receber -->
                <app-financeiro-contas-receber
                  *ngIf="abaAtiva === 'contas-receber'"
                ></app-financeiro-contas-receber>

                <app-financeiro-orcamento
                  *ngIf="abaAtiva === 'orcamento'"
                ></app-financeiro-orcamento>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
